import { Alert } from 'antd';
import React from "react";

// Supplier steps read the finisher's delivery address (item_delivery_address[0]).
// Without it there is nothing to ship to, so show this instead of the task.
const MissingFinisherAddress = () => (
    <div>
        <h3>Task For You</h3>
        <Alert type="warning" showIcon message="The finisher's delivery address is not set for this order. Please contact Leoprinting." />
    </div>
)

export default MissingFinisherAddress;
